import { Dialog, Transition } from '@headlessui/react'
import React, { Fragment } from 'react';
import SmallSpinner from '../Shared/Spinner/SmallSpinner';

const EnrollModal = ({ isOpen, closeModal, loading, handleSubmit, onSubmit, register }) => {
    return (
        <div className='z-50 '>
            <Transition appear show={isOpen} as={Fragment}>
                <Dialog as="div" className="relative z-50" onClose={closeModal}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center ">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-xl transform overflow-hidden rounded-2xl bg-white p-5 md:p-11 text-left align-middle shadow-xl transition-all ">
                                    <Dialog.Title
                                        as="h3"
                                        className="font-medium leading-6 text-center"
                                    >
                                        <h3 className='text-2xl font-semibold text-indigo-500 pb-2'>Please Fill up this form</h3>
                                        <p className='text-xl mx-auto'>After fill up this form our team will contact with you.</p>
                                    </Dialog.Title>
                                    <form onSubmit={handleSubmit(onSubmit)}>
                                        <div className="mt-6 max-w-sm mx-auto ">

                                            <div classname='mt-6'>
                                                <label for="email" class="block text-sm text-gray-500 dark:text-gray-300">Name</label>

                                                <input type="name" class="mt-2 block w-full placeholder-gray-400/70 rounded-lg border border-gray-200 bg-gray-100 px-5 py-2.5 text-gray-700 focus:border-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-40 dark:border-gray-600 dark:bg-gray-900 dark:text-gray-300 dark:focus:border-blue-300" 
                                                {...register("name")}
                                                required
                                                />
                                            </div>
                                            <div className='mt-4'>
                                                <label for="email" class="block text-sm text-gray-500 dark:text-gray-300">Email Address</label>

                                                <input type="email" class="mt-2 block w-full placeholder-gray-400/70 rounded-lg border border-gray-200 bg-gray-100 px-5 py-2.5 text-gray-700 focus:border-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-40 dark:border-gray-600 dark:bg-gray-900 dark:text-gray-300 dark:focus:border-blue-300" 
                                                {...register("email")}
                                                required
                                                />
                                            </div>
                                            <div className='mt-4'>
                                                <label for="text" class="block text-sm text-gray-500 dark:text-gray-300">Mobile Number</label>

                                                <input type="text" class="mt-2 block w-full placeholder-gray-400/70 rounded-lg border border-gray-200 bg-gray-100 px-5 py-2.5 text-gray-700 focus:border-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-40 dark:border-gray-600 dark:bg-gray-900 dark:text-gray-300 dark:focus:border-blue-300" 
                                                {...register("mobile")}
                                                required
                                                />
                                            </div>
                                            <div className='mt-4'>
                                                <label for="text" class="block text-sm text-gray-500 dark:text-gray-300">Your Choicefull Course</label>

                                                <select type="text" class="mt-2 block w-full placeholder-gray-400/70 rounded-lg border border-gray-200 bg-gray-100 px-5 py-2.5 text-gray-700 focus:border-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-40 dark:border-gray-600 dark:bg-gray-900 dark:text-gray-300 dark:focus:border-blue-300" 
                                                {...register("course")}
                                                required
                                                >
                                                    <option >Select</option>
                                                    <option value="Microsoft Office Programme">Microsoft Office Programme</option>
                                                    <option valu="Microsoft Powerpoint">Microsoft Powerpoint</option>
                                                    <option value="Photoshop">Photoshop</option>
                                                    <option value="Microsoft Excel">Microsoft Excel</option>
                                                    <option value="Google Sheet And Docs">Google Sheet and Docs</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div className="mt-9 max-w-sm mx-auto">
                                            <button
                                                type="submit"
                                                className="inline-flex justify-center rounded-md border border-transparent bg-indigo-500 w-44 h-12 text-lg font-medium text-white hover:bg-indigo-600 flex items-center justify-center focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                                            >
                                                {
                                                    loading ?
                                                        <SmallSpinner />
                                                        :
                                                        "Submit"
                                                }
                                            </button>
                                        </div>
                                    </form>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </div>
    );
};

export default EnrollModal;